
import {Component, Mixins, Prop, Ref, Watch} from "vue-property-decorator";
import Dates from "@/components/inputs/Dates.vue";
import Tutar from "@/components/inputs/Tutar.vue";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import {ParaBirimi} from "@/enum/ParaBirimi";
import FormWrapper from "@/components/FormWrapper.vue";
import Faizler from "@/components/forms/Faizler.vue";
import ParaBirimiPicker from "@/components/pickers/ParaBirimiPicker.vue";
import {AlacakBelgeTuru, AlacakBelgeTuruLabel} from "@/enum/AlacakBelgeTuru";
import {TakipTalebiEntity} from "@/entity/TakipTalebiEntity";
import {DovizTakipSekli} from "@/enum/DovizTakipSekli";
import Kur from "@/components/inputs/Kur.vue";
import {AlacakEntity} from "@/entity/AlacakBelgeler/AlacakEntity";
import DovizTakipSekliPicker from "@/components/pickers/DovizTakipSekliPicker.vue";
import AlacakKalemiEntity from "@/entity/AlacakBelgeler/AlacakKalemiEntity";
import {TakipTarihliKurEntity} from "@/entity/TakipTarihliKurEntity";
import {FaizTuruEntity} from "@/entity/FaizTuruEntity";
// import {TakipTarihliKurEntity} from "@/entity/TakipTarihliKurEntity";
@Component({
  components: {
    Kur,
    ParaBirimiPicker,
    FormWrapper,
    Tutar,
    Dates,
    Faizler,
    DovizTakipSekliPicker,
  },
})
export default class AsilAlacakKalemiForm extends Mixins(ObjectInputMixin) {
  @Prop() hideButtons!: boolean | string;
  @Prop() alacakBelgeTuruId!:number
  @Prop() alacak!: AlacakEntity;
  @Prop() takipTarihliKurlar!: Array<TakipTarihliKurEntity>;

  @Ref('form') readonly form!: FormWrapper;

  readonlyParaBirimi = false;
  paraBirimi = ParaBirimi;
  dovizTakipSekli = DovizTakipSekli;
  AlacakBelgeTuru = AlacakBelgeTuru;

  async save(){
    if (this.alacak.id){
      this.localValue.alacak_kalemi_alani_id = 1
      this.localValue.alacak_id = this.alacak.id

      if (this.alacak.alacak_belge_turu_id !== this.AlacakBelgeTuru.apartman_alacagi){
        this.localValue.gecikme_tazminati_mi = false
      }else{
        if (this.localValue.gecikme_tazminati_mi){
          this.localValue.gecikme_tazminati_mi = true
        }else{
          this.localValue.gecikme_tazminati_mi = false
        }
      }
      if (this.localValue.elle_faiz_oran_mi){
        if (this.localValue.elle_faiz_mi && this.localValue.takip_sonrasi_faiz_turu) {
          const faizTuruId = await this.$helper.saveFaizTuru(this.localValue.takip_sonrasi_faiz_turu, this.$route.params.id);
          this.localValue.takip_oncesi_faiz_turu_id = faizTuruId;
          this.localValue.takip_sonrasi_faiz_turu_id = faizTuruId;
        } else {
          this.localValue.takip_oncesi_faiz_turu_id = await this.$helper.saveFaizTuru(this.localValue.takip_oncesi_faiz_turu, this.$route.params.id);
          this.localValue.takip_sonrasi_faiz_turu_id = this.localValue.takip_oncesi_faiz_turu_id;
        }
      }
      if (this.localValue.id){
        await this.$http.put('/api/v1/alacak-kalemi/' + this.localValue.id,this.localValue);
        this.$emit("addAsilAlacak",this.localValue);
        this.$emit("onSuccess");
      }else{
        await this.$http.post('/api/v1/alacak/' + this.alacak.id + '/alacak-kalemi',this.localValue);
        this.$emit("addAsilAlacak",this.localValue);
        this.$emit("onSuccess");
      }
    }else{
      this.$emit("addAsilAlacak",this.localValue);
      this.$emit("onSuccess");
    }

  }



  get dateRule() {
    if (this.alacak.alacak_belge_turu_id == AlacakBelgeTuru.cek) {
      if (this.localValue.ibraz_tarihi) {
        if (new Date(this.alacak.keside_tarihi).getTime() <= new Date(this.localValue.ibraz_tarihi).getTime())
          return [true];
        else
          return ['Keşide Tarihinden daha önce bir ibraz tarihi girilemez.'];
      } else
        return ['Lütfen bu alanı doldurun.'];
    } else if (this.alacak.alacak_belge_turu_id == AlacakBelgeTuru.police) {
      if (this.localValue.vade_tarihi) {
        if (new Date(this.alacak.keside_tarihi).getTime() <= new Date(this.localValue.vade_tarihi).getTime()) {
          return [true];
        } else
          return ['Keşide Tarihinden daha önce bir vade tarihi girilemez.'];
      }
    } else if ([AlacakBelgeTuru.fatura, AlacakBelgeTuru.mts, AlacakBelgeTuru.senet, AlacakBelgeTuru.bono].indexOf(this.alacak.alacak_belge_turu_id) != -1) {
      if (this.localValue.vade_tarihi) {
        if (new Date(this.alacak.tanzim_tarihi).getTime() <= new Date(this.localValue.vade_tarihi).getTime()) {
          return [true];
        } else
          return ['Tanzim Tarihinden daha önce bir vade tarihi girilemez.'];
      }
    } else {
      if (this.localValue.vade_tarihi) {
        return [true];
      }
    }
  }

  @Watch('localValue.para_birimi_id')
  onParaBirimiIdChange() {
    this.addParaBirimi();
  }

  addParaBirimi() {
    if (this.localValue.takip_tarihli_kurlar &&
        this.localValue.para_birimi_id != ParaBirimi.TRY &&
        !this.localValue.takip_tarihli_kurlar.find((kur:any) => kur.para_birimi_id == this.localValue.para_birimi_id)) {
      let kur = new TakipTarihliKurEntity();
      kur.para_birimi = this.localValue.para_birimi;
      kur.para_birimi_id = this.localValue.para_birimi_id;
      kur.tutar = null;
      this.localValue.takip_tarihli_kurlar.push(kur);
    }
  }

  onParaBirimiChange() {
    this.addParaBirimi();
    this.localValue?.asil_alacaklar?.forEach((asilAlacak: AlacakKalemiEntity) => {
      if (this.localValue.para_birimi_id != this.paraBirimi.TRY && this.localValue.doviz_kur_tarihi == DovizTakipSekli.takip) {
        asilAlacak.para_birimi_id = this.localValue.para_birimi_id;
        asilAlacak.para_birimi = this.localValue.para_birimi;
      }
    });
    this.input();
  }
  get minDate() {
    if ((this.alacak.alacak_belge_turu_id === AlacakBelgeTuru.cek || this.alacak.alacak_belge_turu_id == AlacakBelgeTuru.police) && this.alacak.keside_tarihi)
      return this.alacak.keside_tarihi;
    else if ([AlacakBelgeTuru.fatura, AlacakBelgeTuru.mts, AlacakBelgeTuru.senet, AlacakBelgeTuru.bono].indexOf(this.alacak.alacak_belge_turu_id) != -1 && this.alacak.tanzim_tarihi)
      return this.alacak.tanzim_tarihi;
    else
      return null;
  }

  get isHideButtons() {
    return this.hideButtons || this.hideButtons === "";
  }

  get tarih() {
    if (this.localValue.vade_tarihi) {
      return this.localValue.vade_tarihi;
    } else if (this.localValue.ibraz_tarihi) {
      return this.localValue.ibraz_tarihi;
    }
  }

  get aciklama() {
    if (this.alacak.alacak_belge_turu_id && this.localValue.tutar)
      return AlacakBelgeTuruLabel[this.alacak.alacak_belge_turu_id] + " Alacağı";
    else {
      return this.localValue.aciklama;
    }
  }

  get alacakKalemiRules() {
    if (this.localValue.aciklama) {
      if (this.localValue.aciklama.match(/["'<>&]/g) == null)
        return true;
      else
        return `Yasak karakter. ", ', <, >, & karakterleri kullanılamaz.`;
    } else
      return true;
  }

  get shouldShowTakipTarihliKur() {
    return this.isTakipTarihliKurRequiredBelgeTuru();
  }

  get isIlamliTakip(): boolean {
    return this.$helper.isIlamliTakipFromTakipStore();
  }

  isTakipTarihliKurRequiredBelgeTuru(): boolean {
    const belgeTuruId = this.alacak?.alacak_belge_turu_id;
    if (!belgeTuruId) return false;
    
    return belgeTuruId === AlacakBelgeTuru.tuketiciHakemHeyetiKarari ||
           belgeTuruId === AlacakBelgeTuru.diger ||
           belgeTuruId === AlacakBelgeTuru.nafaka ||
           belgeTuruId === AlacakBelgeTuru.isciAlacagi ||
           belgeTuruId === AlacakBelgeTuru.birIsinYapilmasiYaDaYapilmamasi ||
           belgeTuruId === AlacakBelgeTuru.irtifakVeyaIntifakHakkiKaldirilmasi;
  }

  get filteredTakipTarihliKurlar(): Array<TakipTarihliKurEntity> {
    if (!this.localValue.takip_tarihli_kurlar || !this.localValue.para_birimi_id) {
      return [];
    }
    
    return this.localValue.takip_tarihli_kurlar.filter(
      (kur: TakipTarihliKurEntity) => kur.para_birimi_id === this.localValue.para_birimi_id
    );
  }

  @Watch('tutar')
  onTutarChange() {
    this.localValue.tutar = this.tutar;
    this.input();
  }

  get tutar() {
    if (this.alacak.tutar && !this.alacak.id) {
      if (this.alacak.para_birimi_id != this.paraBirimi.TRY && this.alacak.doviz_kur_tarihi == DovizTakipSekli.vade && this.alacak.kur)
        return Number(this.alacak.tutar) * Number(this.alacak.kur);
      else if (this.alacak.para_birimi_id != this.paraBirimi.TRY && this.alacak.doviz_kur_tarihi == DovizTakipSekli.takip) {
        return Number(this.alacak.tutar) * Number(this.alacak.takip_tarihli_kurlar.find((kur:any) => kur.para_birimi_id == this.alacak.para_birimi_id).tutar ?? 1);
      } else
        return this.alacak.tutar;
    }
  }

  private updateParaBirimiState() {
    const paraBirimiId = this.alacak.para_birimi_id;
    const dovizKurTarihi = this.alacak.doviz_kur_tarihi;
    const isForeignCurrency = paraBirimiId !== this.paraBirimi.TRY;
    this.readonlyParaBirimi = false;
    if (!isForeignCurrency) {
      this.localValue.para_birimi_id = this.paraBirimi.TRY;
      return;
    }
    switch (dovizKurTarihi) {
      case DovizTakipSekli.tahsilat:
        this.readonlyParaBirimi = true;
        this.localValue.para_birimi_id = paraBirimiId;
        break;
      case DovizTakipSekli.vade:
      case DovizTakipSekli.takip:
        this.readonlyParaBirimi = true;
        this.localValue.para_birimi_id = paraBirimiId;
        break;
    }
  }

  @Watch('alacak.para_birimi_id')
  onAlacakParaBirimiChange() {
    this.updateParaBirimiState();
  }

  @Watch('alacak.doviz_kur_tarihi')
  onAlacakDovizKurTarihiChange() {
    this.updateParaBirimiState();
    this.input();
  }

  @Watch("tarih")
  onVadeTarihiChange() {
    this.localValue.faiz_baslangic_tarihi = this.tarih;
  }


  @Watch("aciklama")
  onAciklamaChange() {
    if (!this.localValue.id) {
      this.localValue.aciklama = this.aciklama;
      this.input();
    }
  }

  mounted() {
    this.updateParaBirimiState();

    if (this.localValue.id) {
      this.localValue.takip_tarihli_kurlar = this.takipTarihliKurlar;
    } else {
      this.localValue.takip_tarihli_kurlar = [];
    }

  }
}
